import {
  Box,
  Text,
  Card,
  CardBody,
  Badge,
  BankIcon,
  Button,
  Alert,
} from '@razorpay/blade/components';
import {
  BorderedBox,
  FormFieldsWrapper,
  FormFooterWrapper,
} from 'components/EmployeeOnboarding/components/styles';
import { routePaths } from 'components/Routes/data';
import { useHistory } from 'react-router-dom';

interface BankAccountCardProps {
  accountNumber: string;
  ifsc: string;
  isVerified?: boolean;
  isPendingOnApproval?: boolean;
}

export const BankAccountCard = ({
  accountNumber,
  ifsc,
  isVerified = false,
  isPendingOnApproval = false,
}: BankAccountCardProps) => {
  const history = useHistory();
  const badgeProps = isVerified
    ? { color: 'positive' as const, label: 'Verified' }
    : { color: 'notice' as const, label: 'Pending' };

  return (
    <>
      <FormFieldsWrapper>
        <BorderedBox>
          {isPendingOnApproval && (
            <Alert
              isDismissible={false}
              color="information"
              title="Approval Pending"
              description="Your bank account details will be updated after admin approval. Until then, your current bank account details will be used for payments."
            />
          )}
          <Card padding="spacing.5">
            <CardBody>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                marginBottom="spacing.3">
                <BankIcon size="medium" color="surface.icon.gray.normal" />
                <Badge size="small" color={badgeProps.color} emphasis="subtle">
                  {badgeProps.label}
                </Badge>
              </Box>
              <Text marginTop="spacing.5" marginBottom="spacing.3" weight="semibold">
                {accountNumber}
              </Text>

              <Text color="surface.text.gray.muted">IFSC Code: {ifsc}</Text>
            </CardBody>
          </Card>
        </BorderedBox>
      </FormFieldsWrapper>
      <FormFooterWrapper>
        <Button
          variant="tertiary"
          size="medium"
          onClick={() =>
            history.push(routePaths.employeeOnboarding.contractorSelfOnboarding.kycDetails)
          }>
          Back
        </Button>
        <Button
          variant="primary"
          size="medium"
          onClick={() =>
            history.push(routePaths.employeeOnboarding.contractorSelfOnboarding.personalDetails)
          }>
          Continue
        </Button>
      </FormFooterWrapper>
    </>
  );
};
